export default "__VITE_ASSET__7fde7366__"